var app = angular.module('miniRegistration',['ngAnimate','pop.directives']);

app.controller('MainCtrl',function($scope,regService, $rootScope){
	var timeout,
		$message = $('#message');

	$rootScope.apiURL = "https://api.pop.co";
	$rootScope.ajax = false;

	$scope.selectedDomain = null;
	$scope.domainAvailable = false;
	$scope.firstSuggestion = false;
	$scope.suggestions = [];
	$scope.success = false;

	$scope.formData = {};
	$scope.selectedDomain = null;
	$scope.formData.comm_pref = "email";
	$scope.formData.confirm_terms = 1;
	$scope.formData.username = "empty";
	$scope.formData.bundle = "promo-bundle";

	if (typeof POP.registrationServiceSettings != 'undefined') {
		$scope.formData.services = POP.registrationServiceSettings;
		void 0;
	}

	$scope.error = false;

	$scope.shareText = escape(shareText);
	$scope.shareUrl = "";

	$scope.$watch('formData.domain', function(viewvalue) {
		if(typeof viewvalue != 'undefined' && viewvalue.length > 2)
		{
			$scope.selectedDomain = null;
			$scope.suggestions = [];
			$scope.domainAvailable = false;

			if(timeout)
				clearTimeout(timeout);

			timeout = setTimeout(function(){
				$scope.checkDomain();
			},1000);
		}
	});

	$scope.checkDomain = function() {
		$scope.success = false;
		$scope.error = false;

		regService.checkDomain($scope.formData.domain).then(function(resp){
			// handle error messaging
			if (resp.code && resp.code != 200) {
				POP.Message.response($message, resp);
				$scope.error = true;
			}

			// handle only returning a single available domain (no suggestions)
			if (!resp.similar_domains || !resp.similar_domains.length) {
				// set defaults
				$scope.suggestions = [];
				$scope.firstSuggestion = false;
				$scope.exactMatch = false;

				regService.expedrionTrackSearch($scope.formData.domain, (resp.available ? 'a' : 'r'));

				return;
			}

			$scope.firstSuggestion = resp.similar_domains.shift();
			$scope.suggestions = resp.similar_domains;
			$scope.domainAvailable = resp.available;
			$scope.exactMatch = $scope.firstSuggestion.Domain == $scope.formData.domain || ($scope.firstSuggestion.Domain == $scope.formData.domain + '.co');

			if (!$scope.exactMatch) {
				$scope.suggestions.unshift($scope.firstSuggestion);
			}
			
			void 0;

			regService.expedrionTrackSearch($scope.formData.domain, (resp.available ? 'a' : 'r'));

		}, function(err){
			// todo: error handling
			// $scope.error = true;

			$scope.domainAvailable = false;
			$scope.notAvailable = true;
			void 0;
		});
	}

	$scope.registerDomain = function(){
		$scope.success = false;
		$scope.error = false;

		$scope.formData.domain = $scope.selectedDomain.Domain;
		$scope.formData.services.domain = 'domain-' + $scope.selectedDomain.TLD +'-bundle';

		regService.registerDomain($scope.formData).then(function(resp){
			if(resp.code === 200)
			{
				$scope.success = true;
				$scope.shareText = $scope.shareText.replace('xyz',$scope.formData.domain);
				$scope.shareUrl = escape('http://www.' + $scope.formData.domain);
				regService.expedrionTrackSuccess($scope.formData);
			} else {
				$scope.error = true;
				POP.Message.response($message, resp);
			}
			}, function(err){
				void 0;
			}
		);
	}
	
	$scope.$watch('formData.domain',function(){
		$scope.success = false;
		$scope.domainAvailable = false;
		$scope.suggestions = [];
		$scope.error = false;
	});

});
					
app.factory('regService', function($http, $q, $rootScope, transformRequestAsFormPost){
	var service = {},
		deferred;
			
	service.checkDomain = function(domain) {
		if(deferred)
			deferred.resolve();

		deferred = $q.defer();
		$rootScope.ajax = true;
			
		$http({
			url:$rootScope.apiURL + '/domains/available',
			method: 'POST',
			data:JSON.stringify({ "domain": domain, "any_tld": POP.searchTlds }),
			timeout: deferred.promise,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			}
		})
		.success(function(resp) {
			$rootScope.ajax = false;
			deferred.resolve(resp);
		}).
		error(function(err){
			$rootScope.ajax = false;
			deferred.reject();
		});

		return deferred.promise;
	}
			
	service.expedrionTrackSearch = function(domain,available){
		////expedrion tracking
		//deferred = $q.defer();
		/*
		$http.jsonp('http://www.go.co/register/record_search.php?callback=JSON_CALLBACK', {
			params: { d: domain, s:available, exp_referrer:'http://go.co/startupweekend', domain:domain, tld:'.co' }
		});
		*/
	}

	service.expedrionTrackSuccess = function(formData) {
		/*
		$http({
			method: 'POST',
			url:'record_signup.php',
			data: angular.copy(formData),
			transformRequest: transformRequestAsFormPost,
			headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
		});
		*/
	}

	service.registerDomain = function($formData) {
		if(deferred)
			deferred.resolve();

		deferred = $q.defer();
		$rootScope.ajax = true;

		var formData = angular.copy($formData);

		//console.log(formData);

		$http({
			method: 'POST',
			timeout: deferred.promise,
			url: $rootScope.apiURL + '/register/simple',
			data: JSON.stringify(formData),
			//transformRequest: transformRequestAsFormPost,
		})
		.success(function(resp){
			$rootScope.ajax = false;
			deferred.resolve(resp);
		})
		.error(function(err){
			$rootScope.ajax = false;
			deferred.reject();
		});

		return deferred.promise;
	};
			
			
	return service;
			
});

app.factory(
	"transformRequestAsFormPost",
	function() {

		// I prepare the request data for the form post.
		function transformRequest( data, getHeaders ) {
	
			var headers = getHeaders();
			headers[ "Content-type" ] = "application/x-www-form-urlencoded; charset=utf-8";
			return( serializeData( data ) );
		}

		// Return the factory value.
		return( transformRequest );
		// //
		// //
		// // // ---
		// // // PRVIATE METHODS.
		// // // ---
		// //
		// //
		// // // I serialize the given Object into a key-value pair string. This
		// // // method expects an object and will default to the toString() method.
		// // // --
		// // // NOTE: This is an atered version of the jQuery.param() method which
		// // // will serialize a data collection for Form posting.
		// // // --
		// // // https://github.com/jquery/jquery/blob/master/src/serialize.js#L45
		function serializeData( data ) {
			//If this is not an object, defer to native stringification.
			if ( ! angular.isObject( data ) ) {
				return( ( data == null ) ? "" : data.toString() );
			}
			var buffer = [];
			//Serialize each key in the object.
			for ( var name in data ) {
				if ( ! data.hasOwnProperty( name ) ) {
					continue;
				}
				var value = data[ name ];
				buffer.push(encodeURIComponent( name ) + "=" + encodeURIComponent( ( value == null ) ? "" : value ));
			}
			// Serialize the buffer and clean it up for transportation.
			var source = buffer.join( "&" ).replace( /%20/g, "+" );
			return( source );
		}
	}
);

app.directive('ngEnter', function () {
	return function (scope, element, attrs) {
		element.bind("keydown keypress", function (event) {
			if(event.which === 13) {
				scope.$apply(function (){
					scope.$eval(attrs.ngEnter);
				});

				event.preventDefault();
			}
		});
	};
});
